import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from 'utils/api';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import ShowFile from 'shared/components/ShowFile';

class FileAttachments extends Component {
  deleteFileAttachmentMapping(id) {
    /* eslint-disable no-alert */
    if (window.confirm('Are you certain you want to delete this?')) {
      return api.delete(`/agent_portal/api/file_attachment_mappings/${id}`).then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({ message: 'You have deleted a file' });
      });
    }
    return null;
    /* eslint-enable no-alert */
  }

  render() {
    const { referral } = this.props;
    if (referral.fileAttachments.length === 0)
      return <p>There are no longer any files for this referral</p>;
    return (
      <ul>
        {referral.fileAttachments.map(fa => (
          <li key={fa.id}>
            <ShowFile apiEndpoint="/agent_portal/api" file={fa} />
            <span
              data-spec-id={`delete_${fa.id}`}
              onClick={() => this.deleteFileAttachmentMapping(fa.id)}
              className="fake-link"
            >
              <i className="icon icon-trash" />
            </span>
          </li>
        ))}
      </ul>
    );
  }
}

FileAttachments.propTypes = {
  handleSuccess: PropTypes.func.isRequired,
  referral: PropTypes.object.isRequired,
};

export default FileAttachments;
